import { Injectable } from '@angular/core';
import { AuthService } from '@core/service/auth.service';
import { ApplicationConstants } from '@shared/models/constants';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { ConfigurationsService } from 'app/home/configurations/services/configurations.service';

@Injectable({
  providedIn: 'root',
})
export class HelpersService {
  constructor(
    private toastr: ToastrService,
    private authService: AuthService,
    private configService: ConfigurationsService
  ) {}

  getDateFromDbFormatted(dateInUtc: any) {
    if (dateInUtc) {
      return moment(dateInUtc).local().format('YYYY-MM-DDTHH:mm:ssZ');
    } else {
      return '';
    }
  }
  getDateFromDbFormattedDDMMYYYY(dateInUtc: any) {
    if (dateInUtc) {
      return moment(dateInUtc).local().format('DD/MM/YYYY hh:mm A');
    } else {
      return '';
    }
  }
  getDateFromDbFormattedDate(dateInUtc: any) {
    if (dateInUtc) {
      return moment(dateInUtc).local().format('DD/MM/YYYY');
    } else {
      return '';
    }
  }
  getDateFromDb(dateInUtc: Date) {
    return moment(dateInUtc).local();
  }
  getTimeFromDb(dateInUtc: any) {
    return moment(dateInUtc).local().format('hh:mm A');
  }

  getDbTime(time: any) {
    let utcTime = moment(time, 'HH:mm').format('hh:mm A');
    return utcTime;
  }

  getDateInputFormatted(dateInUtc: any) {
    return moment(dateInUtc).format('YYYY-MM-DDTHH:mm:ssZ');
  }

  setDateForDb(dateInLocal: Date) {
    if (dateInLocal) {
      return moment.utc(dateInLocal).format('YYYY-MM-DDTHH:mm:ssZ');
    } else {
      return '';
    }
  }
  setDateFormatted(dateInLocal: Date) {
    if (dateInLocal) {
      return moment(dateInLocal).format('YYYY-MM-DDTHH:mm:ssZ');
    } else {
      return '';
    }
  }
  setDateDepreciationForDb(dateInLocal: Date) {
    if (dateInLocal) {
      return moment.utc(dateInLocal).format('YYYY-MM-DD HH:mm:ssZ');
    } else {
      return '';
    }
  }

  formatDateWithoutConvert(date: Date) {
    if (date) {
      return moment(date).format('YYYY-MM-DD') + ' 00:00:00+00';
    } else {
      return '';
    }
  }

  showDateWithoutConvert(date: Date) {
    if (date) {
      return moment(date).format('DD-MM-YYYY');
    } else {
      return '';
    }
  }

  showDateStringWithoutConvert(date: any) {
    if (date) {
      return moment(date).format('MMMM Do YYYY');
    } else {
      return '';
    }
  }

  showDateStringYYYYMMDD(date: any) {
    if (date) {
      return moment(date).format('YYYY-MM-DD');
    } else {
      return '';
    }
  }

  setDateForDbAvailability(dateInLocal: Date) {
    if (dateInLocal) {
      return moment(dateInLocal).format('YYYY-MM-DD HH:mm:ss+');
    } else {
      return '';
    }
  }

  setDateTime(date: any, time: any) {
    let utcDate = moment(date).utc().format('DD-MM-YYYY');
    // let utcTime = moment(time, 'hh:mm A').format('HH:mm');
    return utcDate + ' ' + time;
    // return utcDate + 'T' + utcTime + 'Z';
  }
  getDateTimeFromUtc(date: any, time: any) {
    let utcDate = moment(date).format('DD-MM-YYYY');
    // let utcTime = moment(time, 'hh:mm A').format('HH:mm');
    return moment(utcDate + ' ' + time)
      .local()
      .format('DD-MM-YYYY hh:mm A');
    // return utcDate + 'T' + utcTime + 'Z';
  }

  getDateFromLocal(date: any) {
    if (date) {
      let utcDate = moment(date).format('DD-MM-YYYY');
      return moment(utcDate).local().format('DD-MM-YYYY');
    }
    return moment();
  }

  cardholderDateFormat(date: any) {
    let cardholderDate = '';
    const dateParts = date.split('/');
    if (dateParts.length === 3) {
        const parsedDate = moment(date, 'DD/MM/YYYY', true);
        if (parsedDate.isValid()) {
          cardholderDate = parsedDate.format('DD/MM/YYYY');
        } else {
          cardholderDate = date ? moment(date).format('DD/MM/YYYY') : '';
        }
    } else {
      cardholderDate = moment(date).isValid()
            ? moment(date).format('DD/MM/YYYY')
            : '';
    }
    return cardholderDate;
  }

  cardholderFormDateFormat(date: any) {
    let cardholderDate = '';
    const dateParts = date.split('/');
    if (dateParts.length === 3) {
        const parsedDate = moment(date, 'DD/MM/YYYY', true);
        if (parsedDate.isValid()) {
          cardholderDate = parsedDate.format('YYYY-MM-DDTHH:mm:ssZ');
        } else {
          cardholderDate = 'Invalid Date';
        }
    } else {
      cardholderDate = moment(date).isValid()
            ? moment(date).format('YYYY-MM-DDTHH:mm:ssZ')
            : 'Invalid Date';
    }
    return cardholderDate;
  }

  showErrorToast(msg: string) {
    if (msg != 'OK') {
      this.toastr.error(msg);
    }
  }

  showSuccessToast(msg: string) {
    this.toastr.success(msg);
  }

  showInfoToast(msg: string) {
    this.toastr.info(msg);
  }

  showCreateSuccessToast() {
    this.toastr.success('Created Successfully', 'Success');
  }

  showDeleteSuccessToast() {
    this.toastr.success('Deleted Successfully', 'Success');
  }

  showUpdateSuccessToast() {
    this.toastr.success('Updated Successfully', 'Success');
  }

  toDecimal(num: Number) {
    return num.toFixed(2);
  }

  showEmailSuccessToast() {
    this.toastr.success('Email Sent Successfully', 'Success');
  }

  isAdmin(role?: string) {
    return (
      this.authService.currentUserValue?.role?.includes(
        ApplicationConstants.ADMIN_ROLE
      ) ?? false
    );
  }

  isReseller(role: string) {
    return (
      this.authService.currentUserValue?.role?.includes(
        ApplicationConstants.RESELLER_ROLE
      ) ?? false
    );
  }

  isPrinter(role: string) {
    return (
      this.authService.currentUserValue?.role?.includes(
        ApplicationConstants.PRINTER_ROLE
      ) ?? false
    );
  }

  isOrgUser() {
    return (
      this.authService.currentUserValue?.role?.includes(
        ApplicationConstants.ORGANIZATION_USER_ROLE
      ) ?? false
    );
  }

  checkUserRole(role: string) {
    return this.authService.currentUserValue?.role?.includes(role) ?? false;
  }

getConfigData(configName: string, defaultValue: any = ""): any {
  try {
    const configRaw = localStorage.getItem('configData');
    if (!configRaw || !configName) return defaultValue;

    const configData = JSON.parse(configRaw);
    if (!Array.isArray(configData)) return defaultValue;

    const found = configData.find((x: any) => x?.name === configName);
    return found?.value ?? defaultValue;
  } catch (error) {
    console.warn('Failed to read configData from localStorage:', error);
    return defaultValue;
  }
}
 
  getConfigurationData() {
    this.configService.getConfigurationList().subscribe((res) => {
      localStorage.setItem('configData', JSON.stringify(res));
    });
  }
}
